module.exports = __webpack_public_path__ + "static/media/mooring_marker_dark_blue.50a524db.svg";